import { Component } from '@angular/core';
import { LanguageService } from '../../services/language.service';

@Component({
    selector: 'app-philosophy',
    templateUrl: 'philosophy.component.html',
    styleUrls: ['../pages.scss', './philosophy.component.scss'],
})

export class PhilosophyComponent  {

    activeLanguage = 'german';
    constructor(private ls: LanguageService) {
      ls.getLanguage().subscribe(val => this.activeLanguage = val);
    }
    content = {
        german: `<div class="row">
        <div class="col">
            <h1 class="header">Beratungsphilosophie</h1>
            <h2 class="subheader margin-below">Kompetente Beratung für Technologiebranchen</h2>
        </div>
        </div>
    <div class="row">
        <div class="text-content col-12 col-sm-6">
            <p class="start-indent">
                Gerade Technologie-orientierte Branchen sind darauf angewiesen, zusätzlich zum Tagesgeschäft Projektthemen
               in Produktion und Entwicklung  effizient und zum Teil parallel zu bearbeiten. Zeit- und budgetgerechte Zielerreichung
                erfordern dazu häufig Ressourcen, die im Unternehmen nicht vorhanden sind oder nicht zur Verfügung stehen.
            </p>
            <p class="start-indent">
                <span class="highlight">Technologie Consulting Wolke</span> bietet sowohl strategische wie auch punktuelle
                Unterstützung in der Weiterentwicklung unserer Kunden an. Wir verbinden unternehmerisches Denken mit
                langjähriger Erfahrung in der Optimierung von Abläufen in der Entwicklung und  Produktion und wie auch in der Unternehmensentwicklung.
            </p>
            <p class="start-indent">
                Unseren Kunden aus in den Bereichen Halbleitertechnik, Automotive, Anlagenbau oder auch Medizintechnik
                bieten wir eine kompetente Beratung, bedarfsgerecht ausgerichtet auf die speziellen Anforderungen und
                Gegebenheiten jedes einzelnen Kunden. Dabei legen wir besonderes Augenmerk darauf, unser Methodenwissen und
                Erfahrungen genau auf die konkrete Situation unserer Kunden anzupassen.
                </p>
            <p class="start-indent">
                <span class="highlight">Technologie Consulting Wolke</span> beschränkt sich nicht auf die fachliche Vermittlung
                von Kenntnissen und Werkzeugen, sondern erarbeitet und begleitet Lösungskonzepte im speziellen Kundenumfeld bis zum
                messbaren Erfolg. Unser Ziel ist der nachhaltige Bestand unserer Beratung und die Entwicklung Ihrer Mitarbeiter!
            </p>
        </div>
        <div class="image-content col-10 col-sm-6 w-100">
            <h2 class="subheader">Aktuelle Referenzen</h2>
            <img class="img-responsive" src="/assets/references.png">
        </div>
    </div>`,
      english: `<div class="row">
      <div class="col">
          <h1 class="header">Our consulting philosophy</h1>
      </div>
      </div>
  <div class="row">
      <div class="text-content col-12 col-sm-6">
          <p class="start-indent">
              In particular technology oriented business units face the need to efficiently execute tasks and
              projects aside of and often in parallel to the daily business work.  In-time and in-budget performance
              of these projects typically require resources, which are not existing or not available without loss of quality in other areas.
          </p>
          <p class="start-indent">
              <span class="highlight">Technologie Consulting Wolke</span> provides both strategic and punctual advisory for
              successful business development for interim time and subject. Our competence is based on multiyear real life experience
              in optimizing processes in R&D and production as well as strategic business development.
          </p>
          <p class="start-indent">
              We provide customer specific high level consultancy to our clients in semiconductor, new energy,
              automotive and medical markets.  Prime focus is to work within the individual situation and environment of our clients.
              Specifically we use our huge base of knowledge, methods and tools  to pick and customize those most suitable,
              rather than providing generic advisory that may or may not be helpful to serve the client’s needs.
              </p>
          <p class="start-indent">
              Sustainable results are guaranteed, since <span class="highlight">Technologie Consulting Wolke</span> does not limit our support to providing
              technical knowledge and a tool box of methods. We acknowledge our client’s existing, and often well proven way of working
              and merge with the on-site team to find solutions and create measurable results within their specific role and function.
              Our commitment is the visible success of our client’s enterprise and the sustainable development of the on-site team!
          </p>
      </div>
      <div class="image-content col-10 col-sm-6 w-100">
          <h2 class="subheader">Some recent references</h2>
          <img class="img-responsive" src="/assets/references.png">
      </div>
  </div>
    `,
    };

}



// WEBPACK FOOTER //
// ./src/app/components/philosophy/philosophy.component.ts